import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = [
        "category", "reports", "report", "preview","download", "downloadDummy", "viewer"
    ]

    connect()
    {
        this.downloadTarget.addEventListener("click",e =>
        {
            this.downloadDummyTarget.click();
        })

        this.categoryTargets.forEach(category => category.addEventListener("click", e =>
        {
            let index = category.dataset["index"];
            this.categoryTargets.forEach(cat => cat.classList.remove("selected"));

            category.classList.add("selected");

            this.reportsTargets.forEach(report => report.classList.add("hidden"));
            this.reportsTargets[parseInt(index)].classList.remove("hidden");
        }))

        this.reportTargets.forEach(report => report.addEventListener("click", e =>
        {
            let code = report.dataset["code"];
            let name = report.dataset["name"];

            report.classList.add("loading");
            fetch(window.App.prefixedUrl(`/forms-guides/document?code=${code}`))
            .then(res =>
            {
                if(!res.ok) throw new Error("An error occurred while retrieving the file.");
                return res.blob()
            })
            .then(blob =>
            {
                this.reportTargets.forEach(r => r.classList.remove("selected"));
                report.classList.add("selected");

                let obj = URL.createObjectURL(blob);

                let iframe = document.createElement("iframe");
                iframe.src = obj;
                iframe.style.width = "100%";
                iframe.style.height = "100%";

                this.viewerTarget.innerHTML ="";
                this.viewerTarget.appendChild(iframe);

                this.downloadDummyTarget.href = obj;
                this.downloadDummyTarget.download = name+".pdf";


                this.previewTarget.classList.remove("hidden");
            

                history.pushState({ page: "data"}, report.dataset["name"] + " - Forms & Guides | usadealer.us", window.App.prefixedUrl("/forms-guides?d="+encodeURIComponent(report.dataset["name"])))
                document.title = report.dataset["name"] + " - Forms & Guides | usadealer.us"
            })
            .catch((e) =>
            {
                console.error(e)
                let toastEvent = new CustomEvent("show-toast", { detail: "An error occurred while loading the parameters." })
                window.dispatchEvent(toastEvent);
                
            })
            .finally(() =>
            {
                report.classList.remove("loading");
            })

        }))
    }
}